import { Component, Input, OnInit } from '@angular/core';
import { Master } from 'src/model/master';
import { Teklif } from 'src/model/teklif';
import { TeklifFiyatDegisiklik } from 'src/model/teklif-fiyat-degisiklik';
import { RestService } from 'src/providers/rest.service';
import { ParaBirimiTutar } from 'src/teklif-isteme-formu/teklif-isteme-formu.component';

declare var $: any;

@Component({
  selector: 'app-teklif-fiyat-gecmisi-modal',
  templateUrl: './teklif-fiyat-gecmisi-modal.component.html',
  styleUrls: ['./teklif-fiyat-gecmisi-modal.component.css']
})
export class TeklifFiyatGecmisiModalComponent implements OnInit {

  modalData: number = null;
  // teklifFiyatGecmisi: TeklifFiyatDegisiklik[];
  teklif: Teklif;
  paraBirimleri: Master[] = null;
  totalTutarText = '0';

  // @Input()
  // public set source(teklifFiyatGecmisi: TeklifFiyatDegisiklik[]) {
  //   if (teklifFiyatGecmisi != null) {
  //     this.teklifFiyatGecmisi = teklifFiyatGecmisi;
  //     // this.reset();
  //   }
  // }

  @Input()
  public set source2(teklifFiyatGecmisiTeklif: Teklif) {
    if (teklifFiyatGecmisiTeklif != null) {
      this.teklif = teklifFiyatGecmisiTeklif;

      this.restService.getMasterTypes([Master.ParaBirimi]).subscribe(result => {
        if (result) {
          this.paraBirimleri = result.ParaBirimi?.map(x => new Master(x));
          this.toplamTutarHesapla();
        }
      });
      // this.reset();
    }
  }

  @Input()
  public set show(ts: number) {
    if (ts) {
      if (this.modalData !== ts) {
        this.modalData = ts;
        // this.reset();
        $('#teklif-fiyat-gecmisi-modal').modal('show');
      }
    }
  }

  constructor(private restService: RestService) { }

  ngOnInit() {
  }

  toplamTutarHesapla() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }
    if (this.teklif.teklifKalemler != null) {
      for (const t of this.teklif.teklifKalemler) {
        const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
        if (index !== -1) {
          array[index].tutar += t.tutar * t.talepKalem.talepEdilen;
        }
      }
    }
    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toLocaleString('tr-TR')} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }
}
